import React, { useState, useMemo } from "react";
import { Table } from "antd";
import { Tooltip } from "antd";
import "./styles.css";
import { useSelector } from "react-redux";
// Pure Component using React.memo
export const Tables = React.memo(
  ({
    data,
    headers,
    pageSize,
    current,
    total,
    onChange,
    onSort,
    sortBy,
    sortOrder,
    pagination,
    customRender = {},
    emptyText,
  }) => {
    const { user, organisationLogin } = useSelector((state) => state.auth);
    const isPermissionCompleted = user?.isCompleted;
    //console.log(isPermissionCompleted, "isPermissionCompleted");

    const columns = useMemo(() => {
      return headers.map((header) => ({
        title: (
          <div className="text-base text-[#06513D] font-normal text-center">
            {header.label}
          </div>
        ),
        dataIndex: header.key,
        key: header.key,
        sorter: false,

        onHeaderCell: () => ({
          onClick: onSort,
        }),
        render: customRender[header.key] // ✅ custom render if exists
          ? customRender[header.key]
          : (text) => (
              <div
                // className=" font-light truncate max-w-[150px] md:max-w-[250px] cursor-pointer"
                title={text}
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  textAlign: "center",
                }}
              >
                {text?.length > 14 ? (
                  <Tooltip title={text}>{text.substring(0, 14)}...</Tooltip>
                ) : (
                  text
                )}
              </div>
            ),
      }));
    }, [headers, sortBy, sortOrder]);

    return (
      <div
        className={` ${
          organisationLogin && !isPermissionCompleted
            ? "blur-sm opacity-40 pointer-events-none"
            : ""
        }`}
      >
        <div className="bg-[#fff] w-full font-[Calibri] font-light  leading-[24px] tracking-[0] text-center overflow-x-auto">
          <div className="min-w-[320px]">
            {/* <Table
            className="custom-pagination"
            dataSource={data}
            columns={columns}
            pagination={{
              current: current,
              pageSize: pageSize,
              total: total,
              onChange: onChange,
              style: {
                marginRight: "40px",
              },
            }}
            scroll={{ x: true }}
          /> */}

            <Table
              className="custom-pagination"
              dataSource={data}
              columns={columns}
              pagination={{
                current: current,
                pageSize: pageSize,
                total: total,
                onChange: onChange,
                style: {
                  marginRight: "40px",
                },
              }}
              scroll={{ x: true }}
              rowClassName={() => "custom-table-row"}
              locale={emptyText ? { emptyText } : undefined}
            />
          </div>
        </div>
      </div>
    );
  },
);
